import {
  useSealedCollectionQuantities,
  useAddToSealedCollection,
  useRemoveFromSealedCollection,
} from '@/hooks/collections/useCollectionCrud'
import { useUserQuantities } from '@/hooks/collections/useUserQuantities'
import { useUserFilters, useHideSealedProduct, useUnhideSealedProduct } from '@/hooks/filters/useUserFilters'

export function useSealedProductActions() {
  useUserQuantities()
  const { data: sealedCollectionQuantities = {} } = useSealedCollectionQuantities()
  const addToSealedCollection = useAddToSealedCollection()
  const removeFromSealedCollection = useRemoveFromSealedCollection()

  const { data: userFilters } = useUserFilters()
  const hideSealedProduct = useHideSealedProduct()
  const unhideSealedProduct = useUnhideSealedProduct()

  return {
    sealedCollectionQuantities,
    addToSealedCollection,
    removeFromSealedCollection,
    userFilters,
    hideSealedProduct,
    unhideSealedProduct,
  }
}
